import AboutSection from "../../Components/HomeSections/AboutSection";
// import AttorneySection from "../../Components/HomeSections/AttorneySection";
import HeroSection from "../../Components/HomeSections/HeroSection";
import PracticeAreas from "../../Components/HomeSections/Practices";
import TestimonialSlider from "../../Components/HomeSections/Testimonials";
import WhyChooseUs from "../../Components/HomeSections/WhyChooseUs";
import ContactForm from "../../Components/HomeSections/ContactForm";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import ServicesList from "../../Components/Services/ServicesList";
import { Helmet } from "react-helmet-async";

const HomePage =()=>{
    return(
        <>
        <Helmet>
  <title>Top Legal Experts & Best Lawyer in Delhi | SKS Law</title>

  <meta
    name="description"
    content="SKS Law Groups & Associates offers expert legal solutions for businesses and individuals with trusted representation, compliance, and IP protection services."
  />
  <meta property="og:title" content="Top Legal Experts & Best Lawyer in Delhi | SKS Law" />
<meta
  property="og:description"
  content="SKS Law Groups & Associates offers expert legal solutions for businesses and individuals."
/>
<meta property="og:url" content="https://skslawgroupsandassociates.com/" />
<meta property="og:type" content="website" />

  <link
    rel="canonical"
    href="https://skslawgroupsandassociates.com/"
  />
</Helmet>

        <Header/>
        <HeroSection/>
        <AboutSection/>
        <PracticeAreas/>
        <WhyChooseUs/>
        {/* <AttorneySection/> */}
        <TestimonialSlider/>
        <ContactForm/>
        <ServicesList/>
        <Footer/>
        </>
    )
}

export default HomePage;